// LOTE G1 — "Fechar como GANHO": quadro único para marcar oportunidade ganha.
// Usado pela página da oportunidade (DealDetalhe) e pelo funil (Pipeline).
// Pede o valor realmente fechado (pré-preenchido com o valor previsto) + data
// do fechamento (padrão hoje). Envia ao backend com PATCH /deals/{id}/stage.
import React, { useEffect, useState } from "react";
import { X, Trophy } from "lucide-react";

const brl = (v) => {
  const n = Number(v || 0);
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
};

const hoje = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
};

const parseCurrency = (txt) => {
  if (typeof txt === "number") return txt;
  const s = String(txt || "").replace(/\s|R\$/g, "").replace(/\./g, "").replace(",", ".");
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : NaN;
};

const formatCurrencyInput = (n) => {
  if (n === "" || n == null || Number.isNaN(Number(n))) return "";
  return Number(n).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export default function GanhoModal({ open, onClose, onConfirm, valorPrevisto, clienteNome, busy }) {
  const [valor, setValor] = useState("");
  const [data, setData] = useState(hoje());
  const [erro, setErro] = useState("");

  useEffect(() => {
    if (open) {
      setValor(formatCurrencyInput(valorPrevisto || 0));
      setData(hoje());
      setErro("");
    }
  }, [open, valorPrevisto]);

  if (!open) return null;

  const confirmar = () => {
    const vf = parseCurrency(valor);
    if (!vf || vf <= 0) { setErro("Informe o valor realmente fechado."); return; }
    if (!data) { setErro("Informe a data de fechamento."); return; }
    onConfirm({ valor_fechado: vf, data_fechamento: data });
  };

  return (
    <div className="fixed inset-0 z-[9000] bg-black/40 flex items-center justify-center p-4" data-testid="ganho-modal-overlay"
         onClick={(e) => { if (e.target === e.currentTarget && !busy) onClose(); }}>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md" role="dialog" aria-modal="true" data-testid="ganho-modal">
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-200">
          <div className="flex items-center gap-2">
            <Trophy className="w-5 h-5 text-amber-500" />
            <h3 className="text-lg font-semibold text-slate-900">Fechar como GANHO</h3>
          </div>
          <button type="button" onClick={onClose} disabled={busy} className="p-1 rounded hover:bg-slate-100" data-testid="ganho-modal-close" aria-label="Fechar">
            <X className="w-5 h-5 text-slate-500" />
          </button>
        </div>
        <div className="px-5 py-4 space-y-4">
          {clienteNome && (
            <div className="text-sm text-slate-600">Cliente: <b className="text-slate-900">{clienteNome}</b></div>
          )}
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Valor fechado (R$)<span className="text-rose-600"> *</span></label>
            <div className="relative">
              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm">R$</span>
              <input
                data-testid="ganho-modal-valor"
                type="text"
                inputMode="decimal"
                value={valor}
                onChange={(e) => setValor(e.target.value)}
                className="w-full pl-10 pr-3 py-2.5 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500"
                placeholder="0,00"
                autoFocus
              />
            </div>
            <div className="text-xs text-slate-500 mt-1">Previsto: {brl(valorPrevisto || 0)}</div>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Data do fechamento</label>
            <input
              data-testid="ganho-modal-data"
              type="date"
              value={data}
              onChange={(e) => setData(e.target.value)}
              className="w-full px-3 py-2.5 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500"
            />
          </div>
          {erro && <div className="text-sm text-rose-600" data-testid="ganho-modal-erro">{erro}</div>}
        </div>
        <div className="px-5 py-4 border-t border-slate-200 flex justify-end gap-3">
          <button type="button" onClick={onClose} disabled={busy}
                  className="px-4 py-2 rounded-lg border border-slate-300 text-slate-700 hover:bg-slate-50"
                  data-testid="ganho-modal-cancelar">Cancelar</button>
          <button type="button" onClick={confirmar} disabled={busy}
                  className="px-4 py-2 rounded-lg bg-emerald-600 text-white hover:bg-emerald-700 font-semibold disabled:opacity-60"
                  data-testid="ganho-modal-confirmar">{busy ? "Salvando…" : "Confirmar ganho"}</button>
        </div>
      </div>
    </div>
  );
}
